import moment from "moment";
import Pako from "pako";

export function getDaysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

export function formatToUSD(value, separateSpan) {
  if (value === null || value === undefined || value === "" || isNaN(value) || isNaN(Number(value))) return '';
  if(separateSpan) return <><span>$</span><span>{new Intl.NumberFormat('en-US', { currency: 'USD' }).format(value)}</span></>
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    .format(value)
    .replace('$', '$ ');
}



  export function formatUSNumber(amountStr) {
  const cleaned = String(amountStr).replace(/,/g, "");
  const n = parseFloat(cleaned);
  return isNaN(n)
    ? ""
    : n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatDate( date ) {
  const dateObj = date ? new Date(date) : new Date();
  const month = dateObj.getMonth() + 1; // getMonth() returns 0–11
  const day = dateObj.getDate();
  const year = dateObj.getFullYear() % 100; // get last two digits

  return `${month}/${day}/${year}`;
}

export function decodeFromUrlSafeBase64(s) { 
  if (!s) return null;
  return JSON.parse(Pako.inflate(Uint8Array.from(atob(s.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0)), { to: 'string' })); 
}

export function sortedArray(arr, getLabel) {
  return arr?.slice()?.sort((a, b) => {
    const labelA = getLabel(a)?.toString().toLowerCase() || "";
    const labelB = getLabel(b)?.toString().toLowerCase() || "";

    if (labelA === "other") return 1;
    if (labelB === "other") return -1;

    return labelA.localeCompare(labelB);
  });
}

  export function  getFormattedUTCDateForCE (value, zone = "America/New_York") {
    if (!value) return '';

    const dateStr = String(value);

    const isMidnightUTC = dateStr.endsWith('T00:00:00') || dateStr.endsWith('T00:00:00');

    if (isMidnightUTC) {
      return moment.utc(value).format("MM/DD/YYYY");
    }

    return moment.utc(value).tz(zone).format("MM/DD/YYYY");
    };


